import defaultClient from '@/plugins/axios/defaultClient'

export default {
  postServicesCodeUse(code) {
    return defaultClient.post(`/services/${code}/use/`)
  },
}
